import React, { useState } from 'react';
import FrontpageHero from '../../../react4xp/components/FrontPageHero'
import Section from '../../../react4xp/components/Section'

function FrontpageHeroPart({ title, intro, imageSrc, imageSrcMedium, imageSrcMobile, video, linkTitle, productList, ctaLink, ctaText }) {
	return (
		<Section bgColor="bg-beige-050">
			<FrontpageHero
				title={title}
				intro={intro}
				image={!video && imageSrc && {
					src: imageSrc.link,
					srcMedium: imageSrcMedium.link,
					srcMobile: imageSrcMobile.link,
					alt: imageSrc.alt,
					width: imageSrc.width,
					height: imageSrc.height
				}}
				video={video}
				linkTitle={linkTitle}
				productList={productList}
				ctaLink={ctaLink}
				ctaText={ctaText}
			/>
		</Section>
	)
}

export default (props) => <FrontpageHeroPart {...props} />;
